import axios from './axios';

export const dataTypesAPI = {
  // Get all data types
  getAll: async () => {
    const response = await axios.get('/data-types/');
    return response.data;
  },

  // Get single data type
  getById: async (id) => {
    const response = await axios.get(`/data-types/${id}`);
    return response.data;
  },

  // Create data type
  create: async (data) => {
    const response = await axios.post('/data-types/', data);
    return response.data;
  },

  // Update data type
  update: async (id, data) => {
    const response = await axios.put(`/data-types/${id}`, data);
    return response.data;
  },

  // Delete data type
  delete: async (id) => {
    await axios.delete(`/data-types/${id}`);
  }
};
